(() => {
  const init = () => {
    const root = document.querySelector('[data-stickaz-buy100]');
    if (!root || root.querySelector('[data-stickaz-live-price]')) return;

    const hero = root.querySelector('.stickaz-offer-hero');
    const summaryPrice = root.querySelector('[data-summary-price]');
    const summaryStyle = root.querySelector('[data-summary-style]');
    const summarySize = root.querySelector('[data-summary-size]');
    const summaryOffer = root.querySelector('[data-summary-offer]');
    const fileInput = root.querySelector('[data-artwork-input]');
    const dropzone = root.querySelector('[data-dropzone]');
    if (!hero || !summaryPrice) return;

    if (!document.getElementById('StickazLivePriceStyles')) {
      const style = document.createElement('style');
      style.id = 'StickazLivePriceStyles';
      style.textContent = `
        .stickaz-live-price-top {
          margin:10px 0 0;
          padding:11px 13px;
          border:2px solid #111;
          border-radius:10px;
          background:#fff;
          color:#111;
          position:-webkit-sticky;
          position:sticky;
          top:8px;
          z-index:50;
          box-shadow:0 5px 18px rgba(0,0,0,.14);
          align-self:flex-start;
        }
        .stickaz-live-price-main {
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:14px;
        }
        .stickaz-live-price-copy span {
          display:block;
          font-size:1rem;
          line-height:1.1;
          font-weight:900;
          letter-spacing:.1em;
        }
        .stickaz-live-price-copy small {
          display:block;
          margin-top:3px;
          color:#666;
          font-size:.95rem;
          line-height:1.2;
        }
        .stickaz-live-price-value {
          font-size:2.25rem;
          line-height:1;
          font-weight:900;
          white-space:nowrap;
        }
        .stickaz-live-price-options {
          display:grid;
          grid-template-columns:repeat(3,minmax(0,1fr));
          gap:7px;
          margin-top:9px;
          padding-top:9px;
          border-top:1px solid #ddd;
        }
        .stickaz-live-price-option {
          min-width:0;
          padding:6px 7px;
          border-radius:7px;
          background:#f4f4f4;
        }
        .stickaz-live-price-option span {
          display:block;
          color:#666;
          font-size:.82rem;
          line-height:1;
          font-weight:800;
          letter-spacing:.05em;
          text-transform:uppercase;
        }
        .stickaz-live-price-option strong {
          display:block;
          margin-top:3px;
          overflow:hidden;
          color:#111;
          font-size:1.03rem;
          line-height:1.15;
          font-weight:900;
          text-overflow:ellipsis;
          white-space:nowrap;
        }
        .stickaz-change-artwork {
          width:100%;
          margin-top:9px;
          padding:10px 12px;
          border:1.5px solid #111;
          border-radius:8px;
          background:#fff;
          color:#111;
          font:inherit;
          font-size:1.05rem;
          font-weight:900;
          letter-spacing:.04em;
          cursor:pointer;
        }
        .stickaz-change-artwork:hover {
          background:#111;
          color:#fff;
        }
        .stickaz-change-artwork[hidden] { display:none !important; }
        @media screen and (max-width:749px) {
          .stickaz-live-price-top {
            position:-webkit-sticky;
            position:sticky;
            top:max(6px, env(safe-area-inset-top));
            padding:9px 10px;
            z-index:80;
          }
          .stickaz-live-price-main { gap:10px; }
          .stickaz-live-price-value { font-size:1.85rem; }
          .stickaz-live-price-options { gap:5px; margin-top:7px; padding-top:7px; }
          .stickaz-live-price-option { padding:5px 6px; }
          .stickaz-live-price-option span { font-size:.72rem; }
          .stickaz-live-price-option strong { font-size:.92rem; }
        }
      `;
      document.head.appendChild(style);
    }

    const panel = document.createElement('div');
    panel.className = 'stickaz-live-price-top';
    panel.setAttribute('data-stickaz-live-price', '');
    panel.setAttribute('aria-live', 'polite');
    panel.innerHTML = `
      <div class="stickaz-live-price-main">
        <div class="stickaz-live-price-copy">
          <span>LIVE PRICE</span>
          <small>Updates as you choose</small>
        </div>
        <strong class="stickaz-live-price-value" data-stickaz-live-price-value></strong>
      </div>
      <div class="stickaz-live-price-options">
        <div class="stickaz-live-price-option"><span>Shape</span><strong data-stickaz-live-shape>—</strong></div>
        <div class="stickaz-live-price-option"><span>Size</span><strong data-stickaz-live-size>—</strong></div>
        <div class="stickaz-live-price-option"><span>Qty</span><strong data-stickaz-live-qty>—</strong></div>
      </div>
    `;
    hero.insertAdjacentElement('afterend', panel);

    const liveValue = panel.querySelector('[data-stickaz-live-price-value]');
    const liveShape = panel.querySelector('[data-stickaz-live-shape]');
    const liveSize = panel.querySelector('[data-stickaz-live-size]');
    const liveQty = panel.querySelector('[data-stickaz-live-qty]');

    const sync = () => {
      liveValue.textContent = summaryPrice?.textContent.trim() || '—';
      liveShape.textContent = summaryStyle?.textContent.trim() || '—';
      liveSize.textContent = summarySize?.textContent.trim() || '—';
      const offerText = summaryOffer?.textContent.trim() || '';
      liveQty.textContent = offerText && offerText !== '—' ? offerText.replace(/^Buy\s+/i, '') : '—';
    };
    sync();

    [summaryPrice, summaryStyle, summarySize, summaryOffer].filter(Boolean).forEach(el => {
      new MutationObserver(sync).observe(el, { childList:true, characterData:true, subtree:true });
    });

    if (fileInput && dropzone && !root.querySelector('[data-change-artwork]')) {
      const changeButton = document.createElement('button');
      changeButton.type = 'button';
      changeButton.className = 'stickaz-change-artwork';
      changeButton.setAttribute('data-change-artwork', '');
      changeButton.textContent = 'CHANGE ARTWORK';
      changeButton.hidden = !(fileInput.files && fileInput.files.length);
      dropzone.insertAdjacentElement('afterend', changeButton);

      changeButton.addEventListener('click', () => fileInput.click());
      fileInput.addEventListener('change', () => {
        changeButton.hidden = !(fileInput.files && fileInput.files.length);
        if (!changeButton.hidden) changeButton.textContent = 'CHANGE ARTWORK';
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once:true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
